import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import api from "../../services/api";
import styles from "./Login.module.css";
import Logo from '../../assets/logo.png';
import ApiButton from "../../components/ApiButton/ApiButton";
import { registrarPush } from "../../services/push";




export default function Login() {
    const [cpf, setCpf] = useState("");
    const [senha, setSenha] = useState("");
    const [loading, setLoading] = useState(false);

    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    const { user } = useContext(AuthContext);


    useEffect(() => {
        if (user) {
            navigate("/home");
        }
    }, [user]);

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!cpf || !senha) return;

        try {
            setLoading(true);

            const response = await api.get(`/colaborador/autentica/?cpffun=${cpf}&senfun=${senha}`);


            const data = response.data;

            // 🔎 Validação baseada no seu retorno real
            if (!data || !data.codfun) {
                alert("Usuário ou senha inválidos");
                return;
            }

            // 🔐 Salva todos os dados do colaborador
            login({
                codemp: data.codemp,
                codfun: data.codfun,
                codset: data.cpf,
                nomfun: data.nomfun,
                confun: data.confun,
                cpffun: data.cpffun,
                desfun: data.desfun,
                funcao: data.funcao,
                nivfun: data.novfun,
                setor: data.setor,
                tipfun: data.tipfun,
                toksim: data.toksim
            });

            // Chamado aqui dentro do próprio clique de login (não num useEffect
            // depois) de propósito - Notification.requestPermission() só
            // dispara o popup de permissão de verdade, em vários navegadores,
            // quando invocado dentro da pilha de um gesto do usuário. Isso
            // tinha ficado comentado numa migração anterior pra centralizar
            // em push.js/App.js, e é o motivo mais provável de "instala mas
            // não registra" em parte dos aparelhos (pedido do usuário,
            // 2026-09-25). App.js ainda cobre reabertura do app depois.
            registrarPush(data.codfun, data.tipfun, api).catch(err =>
                console.error("[push] falha ao registrar no login", err)
            );

            navigate("/home");

        } catch (error) {
            alert("Erro ao conectar com servidor : " + error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.container}>



            <div className={styles.header}>
                <img src={Logo} alt="Logo" className={styles.logo} />
            </div>

            <div className={styles.content}>
                <div className={styles.card}>
                    <h2>Portal do Colaborador</h2>
                    <p className={styles.subtitle}>Acesso</p>

                    <form onSubmit={handleLogin}>
                        <div className={styles.inputGroup}>
                            <input
                                type="text"
                                inputMode="numeric"
                                placeholder="Digite seu CPF"
                                value={cpf}
                                onChange={(e) => setCpf(e.target.value.replace(/\D/g, ""))}
                            />
                        </div>

                        <div className={styles.inputGroup}>
                            <input
                                type="password"
                                placeholder="Digite sua senha"
                                value={senha}
                                onChange={(e) => setSenha(e.target.value)}
                            />
                        </div>

                        <ApiButton className={styles.button} type="submit" disabled={loading}>
                            {loading ? "Iniciando..." : "Acessar"}
                        </ApiButton>
                    </form>

                    <span className={styles.version}>Versão 1.7.0</span>


                </div>
            </div>
        </div>
    );
}